import { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  useMediaQuery,
  Link,
} from '@mui/material';
import { AccountEntity } from '@shared/api';
import { RoutePaths } from '@shared';
import { RouterNavLink } from '@widgets';

interface Props {
  selectedCustomerId: string;
  data: AccountEntity[];
}

export const AccountsList = (props: Props) => {
  const [page, setPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);
  const [reverseDialogOpen, setReverseDialogOpen] = useState<boolean>(false);
  const [detailsDialogOpen] = useState<boolean>(false);
  const [reverseStatusDialogOpen, setReverseStatusDialogOpen] = useState<boolean>(false);

  const largeScreen = useMediaQuery('(min-width:800px)');

  return (
    <>
      {largeScreen ? (
        <Table aria-label='simple table' stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell style={{ width: 100 }} align='center'>
                Account Number
              </TableCell>
              <TableCell style={{ width: 100 }} align='center'>
                Status
              </TableCell>
              <TableCell style={{ width: 100 }} align='center'>
                Product
              </TableCell>
              <TableCell style={{ width: 100 }} align='center'>
                Main Card
              </TableCell>
              <TableCell style={{ width: 100 }} align='center'>
                Reference Number
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.data.map((row, idx) => (
              <TableRow key={idx}>
                <TableCell align='center'>
                  <Link
                    component={RouterNavLink}
                    to={RoutePaths.customersAccountDetails.onNavigate(props.selectedCustomerId, row.accId)}
                    color='primary'
                  >
                    {row.accountNumber_M}
                  </Link>
                </TableCell>
                <TableCell align='center'>{row.status}</TableCell>
                <TableCell align='center'>{row.productName}</TableCell>
                <TableCell align='center'>XXXX {row.mainCard}</TableCell>
                <TableCell align='center'>{row.activationCode}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      ) : (
        <Table aria-label='simple table' stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell style={{ width: 100 }} align='center'>
                Account Number
              </TableCell>

              <TableCell style={{ width: 100 }} align='center'>
                Product
              </TableCell>
              <TableCell style={{ width: 100 }} align='center'>
                Main Card
              </TableCell>
              <TableCell style={{ width: 100 }} align='center'>
                Reference Number
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, idx) => (
              <TableRow key={idx}>
                <TableCell align='center'>
                  <Link
                    component={RouterNavLink}
                    to={RoutePaths.customersAccountDetails.onNavigate(props.selectedCustomerId, row.accId)}
                    color='primary'
                  >
                    {row.accountNumber_M}
                  </Link>
                </TableCell>
                <TableCell align='center'>{row.productName}</TableCell>
                <TableCell align='center'>XXXX {row.mainCard}</TableCell>
                <TableCell align='center'>{row.activationCode}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component='div'
        count={props.data.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(_, value) => setPage(value)}
        onRowsPerPageChange={(e) => {
          setPage(0);
          setRowsPerPage(+e.target.value);
        }}
      />
      <Dialog disableEscapeKeyDown maxWidth='sm' aria-labelledby='confirmation-dialog-title' open={reverseDialogOpen}>
        <DialogTitle id='confirmation-dialog-title'>Reverse Transaction</DialogTitle>
        <DialogContent dividers>
          <p>
            You are about to reverse a transaction.
            <br />
            Please confirm the below transaction details before proceeding.
          </p>
          <Divider style={{ marginTop: 20, marginBottom: 20 }} />
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={() => setReverseDialogOpen(false)}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog disableEscapeKeyDown maxWidth='sm' aria-labelledby='confirmation-dialog-title' open={detailsDialogOpen}>
        <DialogTitle id='confirmation-dialog-title'>Transaction Details</DialogTitle>
      </Dialog>
      <Dialog disableEscapeKeyDown maxWidth='md' aria-labelledby='confirmation-dialog-title' open={reverseStatusDialogOpen}>
        <DialogTitle id='confirmation-dialog-title'>Reverse Transaction Response</DialogTitle>
        <DialogContent dividers />
        <DialogActions>
          <Button color='primary' autoFocus onClick={() => setReverseStatusDialogOpen(false)}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
